export const ADMINISTRATION_ROUTES: Readonly<Record<string, string>> = {
  CUSTOMERS: 'customer',
  INSTANCE: 'instance',
  AUTHENTICATION: 'auth_config',
  USERS: 'user',
  USER_OBJECTS: 'user_objects',
  GROUPS: 'group',
  GROUP_OBJECTS: 'group_objects',
  FUNCTIONS: 'function',
  PERIMETER_PROPERTIES: 'perimeter_properties',
  CONTACTS: 'contact',
  SCALES: 'scales',
  SCALES_INDICATOR: 'indicator_scales',
  SCALES_EVALUATION: 'eval_scales',
  SCALES_RISK: 'risk_scales',
  SCALES_PERIMETER: 'perimeter_scales',
  SCALES_PRIORITY: 'priority_scales',
  SCALES_WEATHER: 'weather_scales',
  SCALES_BUSINESS_STAKES: 'business_impacts_scales',
  CATEGORIES: 'category',
  LABELS: 'label',
  INTERNAL_INDICATORS: 'internal_indicator',
  INTERNAL_METRICS: 'internal_metric',
  PUBLIC_API: 'public_api',
  LOGS: 'log',
  IMPORT_REPORTS: 'import_report',
  PREFERENCES: 'preference',
  LICENSES: 'licenses',
  CUSTOMER_CONNECTORS: 'customer_connector',
  JOBS: 'jobs',
  CONNECTORS: 'connector',
  WORKERS: 'worker',
  PROPERTIES: 'properties',
  RISKS: 'risk-analysis-catalog',
  RISKS_CATALOG: 'risks_catalog',
  BUSINESS_VALUES_CATALOG: 'business_value_catalog',
  SUPPORTING_ASSETS_CATALOG: 'supporting_asset_catalog',
  THREATS_CATALOG: 'threat_catalog',
  CATALOG_SYNC: 'catalog_sync',
  LOGIN_MESSAGE: 'login-message',
}
